import React from "react";
import { Checkbox } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const CheckboxField = ({ field, control, disabled, error, required }) => (
  <Controller
    control={control}
    name={field.code}
    render={({ field: input }) => (
      <FieldFrame field={field} error={error} isRequired={required}>
        <Checkbox isChecked={Boolean(input.value)} onChange={(event) => input.onChange(event.target.checked)} isDisabled={disabled}>
          {field.helpText || field.label}
        </Checkbox>
      </FieldFrame>
    )}
  />
);

export default CheckboxField;
